import { IFilterElement } from "@saleor/components/Filter";
import {
  CurrencyrateFilterKeys,
  CurrencyrateListFilterOpts
} from "@saleor/currencyrate/components/CurrencyrateListPage";
import {
  CurrencyrateListUrlFilters,
  CurrencyrateListUrlFiltersEnum,
  CurrencyrateListUrlQueryParams
} from "@saleor/currencyrate/urls";
import { maybe, parseBoolean } from "@saleor/misc";
import { CurrencyrateFilterInput } from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

export const ATTRIBUTE_FILTERS_KEY = "currencyrateFilters";

export function getFilterOpts(
  params: CurrencyrateListUrlFilters
): CurrencyrateListFilterOpts {
  return {
    // isPrimaryExchangeRateCurrency: {
    //   active: params.isPrimaryExchangeRateCurrency !== undefined,
    //   value: maybe(() =>
    //     parseBoolean(params.isPrimaryExchangeRateCurrency, true)
    //   )
    // },
    // isPrimaryStoreCurrency: {
    //   active: params.isPrimaryStoreCurrency !== undefined,
    //   value: maybe(() => parseBoolean(params.isPrimaryStoreCurrency, true))
    // },
    isPublished: {
      active: params.isPublished !== undefined,
      value: maybe(() => parseBoolean(params.isPublished, true))
    }
  };
}

export function getFilterVariables(
  params: CurrencyrateListUrlFilters
): CurrencyrateFilterInput {
  return {
    // isPrimaryExchangeRateCurrency:
    //   params.isPrimaryExchangeRateCurrency !== undefined
    //     ? parseBoolean(params.isPrimaryExchangeRateCurrency, false)
    //     : undefined,
    // isPrimaryStoreCurrency:
    //   params.isPrimaryStoreCurrency !== undefined
    //     ? parseBoolean(params.isPrimaryStoreCurrency, false)
    // : undefined,
    isPublished:
      params.isPublished !== undefined
        ? parseBoolean(params.isPublished, false)
        : undefined,
    search: params.query
  };
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CurrencyrateListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  CurrencyrateListUrlQueryParams,
  CurrencyrateListUrlFilters
>(CurrencyrateListUrlFiltersEnum);

export function getFilterQueryParam(
  filter: IFilterElement<CurrencyrateFilterKeys>
): CurrencyrateListUrlFilters {
  const { name } = filter;

  switch (name) {
    case CurrencyrateFilterKeys.isPrimaryExchangeRateCurrency:
      return getSingleValueQueryParam(
        filter,
        CurrencyrateListUrlFiltersEnum.isPrimaryExchangeRateCurrency
      );

    case CurrencyrateFilterKeys.isPrimaryStoreCurrency:
      return getSingleValueQueryParam(
        filter,
        CurrencyrateListUrlFiltersEnum.isPrimaryStoreCurrency
      );

    case CurrencyrateFilterKeys.isPublished:
      return getSingleValueQueryParam(
        filter,
        CurrencyrateListUrlFiltersEnum.isPublished
      );
  }
}
